import { Injectable } from '@angular/core'
import { deleteDoc, doc, DocumentReference, Firestore } from '@angular/fire/firestore'
import { ref, Storage, StorageReference } from '@angular/fire/storage'
import moment from 'moment'

@Injectable({ providedIn: 'root' })
export class DocumentStorageService {
  constructor(private store: Firestore, private storage: Storage) {}

  // discriminator disambiguates same-day/same-type documents that would otherwise collide and
  // overwrite each other, e.g. idcards for the same dog issued by different trainers on the same day
  getDocumentName(date: moment.Moment, type: string, filename: string, discriminator?: string): string {
    const datePart = date.format('YYYY_MM_DD')
    const ext = filename.split('.').pop()
    const suffix = discriminator ? `_${this.hash(discriminator)}` : ''
    return `${datePart}_${type}${suffix}.${ext}`
  }

  private hash(value: string): string {
    let hash = 0
    for (let i = 0; i < value.length; i++) {
      hash = (hash << 5) - hash + value.charCodeAt(i)
      hash |= 0
    }
    return Math.abs(hash).toString(36)
  }

  getDocumentFirebaseDoc(collectionName: string, entityId: string, docId: string): DocumentReference {
    return doc(this.store, collectionName, entityId, 'documents', docId)
  }

  getDocumentStorageRef(collectionName: string, entityId: string, docId: string): StorageReference {
    return ref(this.storage, `${collectionName}/${entityId}/documents/${docId}`)
  }

  async deleteExpiringDocumentEntry(entityId: string, type: string): Promise<void> {
    await deleteDoc(doc(this.store, 'expiring-documents', `${entityId}_${type}`))
  }
}
